import { DecodeHtml } from '../../utils/decodeHtml'

const NewsSection = ({ college }) => {
  const news = college?.news_holder?.items?.map(item => {
    item = item?.content?.properties
    return {
      title: item?.title,
      description: DecodeHtml({ html: item?.description?.markup })
    }
  })

  return (
    <div className='flex flex-col gap-8 p-4 md:px-10 w-full'>
      <h1 className='text-3xl font-bold '>New & Updates</h1>
      <div className='grid grid-cols-[repeat(auto-fill,_minmax(30rem,_1fr))]  w-full gap-5'>
        {news?.map((d, i) => (
          <div key={i} className='flex flex-col gap-5 h-fit w-full'>
            <h2 className=' font-semibold '>{d?.title}</h2>
            <div className='text-sm'>{d?.description}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default NewsSection
